import { useState } from 'react';
import { useForm } from 'react-hook-form';

export type FormDataType = {
  [key: string]: string;
};

export const useFormData = () => {
  const [formValues] = useState<any>({
    widgetName: '',
    wetWell: '',
    leftPump: '',
    rightPump: '',
    controller: '',
    assetProperties: {
      wetWell: {},
      leftPump: {},
      rightPump: {},
    },
  });

  const methods = useForm<FormDataType>({
    defaultValues: formValues,
  });
  const { watch, handleSubmit } = methods;

  const values = watch();

  const selectedWetWell = watch('wetWell');
  const selectedLeftPump = watch('leftPump');
  const selectedRightPump = watch('rightPump');
  const selectedController = watch('controller');

  return {
    methods,
    handleSubmit,
    values,
    selectedWetWell,
    selectedLeftPump,
    selectedRightPump,
    selectedController,
  };
};
